import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../../module_auth/AuthService"
import '../../App.css'
import { Helmet } from 'react-helmet';
import { MapContainer, TileLayer } from 'react-leaflet'
import { CustomMarker } from './CustomMarker';
import Select from 'react-select'
import { getGeoPosition, sendGoogleAnalytics } from "../../component/common/BaseUtil"
import { ChangeView } from './ChangeView';
import { ALL, optionsFilterType } from './MapConstant'
//user tracking
import { useLocation } from "react-router-dom";

export function MapHome({ compactLayout = false }) {
  const location = useLocation();

  const zoomLevelInitial = 13;
  const topPadding = compactLayout ? '20px' : '110px';
  const [currentZoomLevel, setcurrentZoomLevel] = useState(13);

  const [koreaTownList, setKoreaTownList] = useState([]);
  const [koreaTownListSelected, setKoreaTownListSelected] = useState([]);

  const [position, setPosition] = useState([52.525, 13.369]); //initial position as Berlin

  const [showPermanentTooltip, setShowPermanentTooltip] = useState(true);

  const [cityList, setCityList] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [foundCity, setFoundCity] = useState(null);
  const [mapReloadKey, setMapReloadKey] = useState(0);

  const [activeFilterType, setActiveFilterType] = useState(ALL);

  useEffect(() => {
    sendGoogleAnalytics(location.pathname)

    getCityList();

    let url = basePort + '/get/koreatown/map/all'
    fetch(url,
      {
        method: 'GET', headers,
        body: JSON.stringify()
      })
      .then(response => response.json())
      .then(response => {
        setKoreaTownList(response.entityList)
        setKoreaTownListSelected(response.entityList)
      }).catch(error => console.log(error))
  }, [currentZoomLevel]);

  const handleChangeFilter = (selected) => {
    if (selected) {
      console.log("selected:", selected)
      setActiveFilterType(selected)
      const seleted = koreaTownList.filter(item => item.storeType === selected.value);
      setKoreaTownListSelected(seleted);
    } else {
      setActiveFilterType(ALL)
      setKoreaTownListSelected(koreaTownList);
    }
  };

  const handleLevel = (level) => {
    setcurrentZoomLevel(level);
    if (level < zoomLevelInitial) {
      setShowPermanentTooltip(false)
    } else {
      setShowPermanentTooltip(true)
    }
  };

  const handleChange = (selected) => {
    setSelectedOption(selected); // state에 선택된 옵션을 저장합니다.

    if (selected) {
      const cityEntity = cityList.find(city => city.id === selected.value);
      setFoundCity(cityEntity);
      setPosition(getGeoPosition(cityEntity.latitude, cityEntity.longitude))
      setMapReloadKey(prevKey => prevKey + 1);
    }
  };

  function getCityList() {
    let url = basePort + '/get/config'
    fetch(url,
      {
        method: 'GET', headers,
        body: JSON.stringify()
      })
      .then(response => response.json())
      .then(response => {
        setCityList(response.cityEntityList)

        let options = response.cityEntityList.map(city => ({
          value: city.id,    // 도시 객체의 'id'를 'value'로 매핑
          label: city.cityName   // 도시 객체의 'name'을 'label'로 매핑
        }));
        setOptions(options)

      }).catch(error => console.log(error))
  }

  return (
    <div>
      <Helmet>
        {/* 기본 Meta */}
        <title>지워커 | 독일 한인 지도·전문가·생활정보 플랫폼</title>
        <meta name="description" content="독일 거주 한인을 위한 필수 생활 정보 플랫폼! 한인지도, 엄선된 한인전문가 프로필, 현지 생활·정착 블로그 정보를 한눈에 확인하세요." />
        <meta name="keywords" content="지워커, gworker, 독일 한인 지도, 독일 한인 전문가, 독일 한인업소, 독일 생활 정보, 독일 한인 블로그" />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.g-worker.co.kr/" />

        {/* Open Graph (SNS 공유용) */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="지워커 (G-Worker)" />
        <meta property="og:title" content="지워커 | 독일 한인 지도·전문가·생활정보 플랫폼" />
        <meta property="og:description" content="독일 거주 한인을 위한 필수 생활 정보 플랫폼! 한인지도, 엄선된 한인전문가 프로필, 현지 생활·정착 블로그 정보를 한눈에 확인하세요." />
        <meta property="og:image" content="https://www.g-worker.co.kr/gworker_logo.jpg" />
        <meta property="og:url" content="https://www.g-worker.co.kr/" />
        <meta property="og:locale" content="ko_KR" />
      </Helmet>
      <main class="page lanidng-page">
        <section>

          <div class="container" style={{ paddingTop: topPadding, width: 'auto', marginBottom: '5px', position: 'relative', zIndex: 1000, display: 'flex', gap: '10px' }}>
            <Select styles={{ flex: 1, container: (provided) => ({ ...provided, width: '200px' }), }} options={options} onChange={handleChange} placeholder="도시명" isClearable={true} />
            <Select styles={{ flex: 1, container: (provided) => ({ ...provided, width: '200px' }), }} options={optionsFilterType} onChange={handleChangeFilter} placeholder="필터" isClearable={true} />
          </div>

          {/* 맵 */}
          <div class="container" hidden={false} style={{ paddingTop: '10px', marginTop: '10px', marginBottom: '10px', height: '100%', width: '100%' }}>
            <MapContainer
              key={mapReloadKey}
              center={position}
              zoom={zoomLevelInitial}
              scrollWheelZoom={true} // 마우스 휠 줌 비활성화 (선택 사항)
              style={{ height: '70vh', width: '100%', borderRadius: '8px' }} // 지도의 크기를 지정합니다.
              zoomControl={false}
            >
              <TileLayer
                attribution='<a href="https://www.g-worker.co.kr/notice?id=154" target="_blank" rel="noopener noreferrer">지도등록안내</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <ChangeView center={position} zoom={zoomLevelInitial} />
              <div class="container">
                {koreaTownListSelected.map((object, index) => (
                  <CustomMarker object={object} index={index}
                    handleLevel={handleLevel} currentZoomLevel={currentZoomLevel} showPermanentTooltip={showPermanentTooltip}
                    cityList={cityList} centerPosition={position}
                  />
                ))}
              </div>
            </MapContainer>
          </div>
        </section>
      </main>
    </div>
  );
}